import React from "react";
import { LicenseJsonModel } from "../../models/BlockTransportSystemJsonModel";
import ModeListBoxWithLicense from "../ModeListBox/ModeListBoxWithLicense";
import { Button, Col, Container, Stack } from "react-bootstrap";

interface IProps {
  exposureLicenses: LicenseJsonModel[];
  listUpLicenses: LicenseJsonModel[];
  selectedExposureLicenses: LicenseJsonModel[];
  selectedListUpLicenses: LicenseJsonModel[];
  onChangeSelectedExposureLicenses: (licenses: LicenseJsonModel[]) => void;
  onChangeSelectedListUpLicenses: (licenses: LicenseJsonModel[]) => void;
  onClickAdd: (licenses: LicenseJsonModel[]) => void;
  onClickRemove: (licenses: LicenseJsonModel[]) => void;
  onClickAddAll: () => void;
  onClickRemoveAll: () => void;
}

const ModeSettingBoxWithLicense: React.FC<IProps> = ({
  exposureLicenses,
  listUpLicenses,
  selectedExposureLicenses,
  selectedListUpLicenses,
  onChangeSelectedExposureLicenses,
  onChangeSelectedListUpLicenses,
  onClickAdd,
  onClickRemove,
  onClickAddAll,
  onClickRemoveAll
}) => {
  const toggleExposureLicense = (license: LicenseJsonModel) => {
    if (selectedExposureLicenses.some(l => l.id === license.id)) {
      onChangeSelectedExposureLicenses(selectedExposureLicenses.filter(l => l.id !== license.id));
    } else {
      onChangeSelectedExposureLicenses([...selectedExposureLicenses, license]);
    }
  };

  const toggleListUpLicense = (license: LicenseJsonModel) => {
    if (selectedListUpLicenses.some(l => l.id === license.id)) {
      onChangeSelectedListUpLicenses(selectedListUpLicenses.filter(l => l.id !== license.id));
    } else {
      onChangeSelectedListUpLicenses([...selectedListUpLicenses, license]);
    }
  };

  return (
    <Container fluid className="d-flex">
      <ModeListBoxWithLicense
        licenses={exposureLicenses}
        selectedLicenses={selectedExposureLicenses}
        onToggleLicense={toggleExposureLicense}
      />
      <Stack gap={2} className="m-2">
        <Button
          variant="outline-primary" className="text-nowrap"
          onClick={() => { onClickAdd(selectedListUpLicenses); onChangeSelectedListUpLicenses([]); }}
        >
          {"<<추가"}
        </Button>
        <Button
          variant="outline-danger" className="text-nowrap"
          onClick={() => { onClickRemove(selectedExposureLicenses); onChangeSelectedExposureLicenses([]); }}
        >
          {">>제거"}
        </Button>
        <Button 
          variant="outline-primary" className="text-nowrap"
          onClick={() => onClickAddAll()}
        >
          {"All 추가"}
        </Button>
        <Button
          variant="outline-danger" className="text-nowrap"
          onClick={() => onClickRemoveAll()}
        >
          {"All 제거"}
        </Button>
      </Stack>
      <ModeListBoxWithLicense
        licenses={listUpLicenses.filter(l => !exposureLicenses.some(el => el.id === l.id))}
        selectedLicenses={selectedListUpLicenses}
        onToggleLicense={toggleListUpLicense}
      />
    </Container>
  )
}

export default ModeSettingBoxWithLicense;